import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { OrderSummaryContentPropsDefault } from '../../components/order-summary/OrderSummary';
import { MarginType } from './margin';
import MarginComponent from '../../components/customComponents/MarginComponent';
import PaddingComponent from '../../components/customComponents/PaddingComponent';
import CustomizePanel from '../../components/order-summary/customize-props';
import { PaddingType } from './padding';
import Border from './Border';
import ColorPicker from './ColorPicker';
import OrderSummaryCart from './orderSummaryCart';

interface OrderSummaryContentProps {
  value: OrderSummaryContentPropsDefault;
  onChange: (_value: OrderSummaryContentPropsDefault) => void;
  title: string;
  showComponent?: boolean;
  showHover?: boolean;
}

const OrderSummaryContent: React.FC<OrderSummaryContentProps> = ({
  value,
  onChange,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <ColorPicker
            value={value.backgroundColor}
            onChange={color => {
              onChange({
                ...value,
                backgroundColor: color,
              });
            }}
            label={'Background Color'}
            tooltip={'backgroundColor'}
          />
          <OrderSummaryCart
            title="Order Summary Cart"
            value={value.productDetails}
            onChange={values => {
              onChange({ ...value, productDetails: values });
            }}
          />
          <CustomizePanel
            title="SubTotal"
            divider={true}
            value={value.Subtotal}
            onChange={values => {
              onChange({ ...value, Subtotal: values });
            }}
            showPlaceholderInput={true}
          />
          <CustomizePanel
            title="Discounts"
            value={value.Discounts}
            onChange={values => {
              onChange({ ...value, Discounts: values });
            }}
            showPlaceholderInput={true}
          />
          <CustomizePanel
            title="Shipping"
            value={value.Shipping}
            onChange={values => {
              onChange({ ...value, Shipping: values });
            }}
            showPlaceholderInput={true}
          />
          <CustomizePanel
            title="Estimated Tax"
            value={value.EstimatedAmount}
            onChange={values => {
              onChange({ ...value, EstimatedAmount: values });
            }}
            showPlaceholderInput={true}
          />
          <CustomizePanel
            title="Sales Tax"
            value={value.SalesTax}
            onChange={values => {
              onChange({ ...value, SalesTax: values });
            }}
            showPlaceholderInput={true}
          />
          <CustomizePanel
            title="Calculated Fee"
            value={value?.CalculatedFees}
            onChange={values => {
              onChange({ ...value, CalculatedFees: values });
            }}
            showPlaceholderInput={false}
          />
          <CustomizePanel
            title="Grand Total"
            divider={true}
            value={value.GrandTotal}
            onChange={values => {
              onChange({ ...value, GrandTotal: values });
            }}
            showPlaceholderInput={true}
          />

          <MarginComponent
            value={value.margin}
            onChange={(values: MarginType) => {
              onChange({ ...value, margin: values });
            }}
          />
          <PaddingComponent
            value={value.padding}
            onChange={(values: PaddingType) => {
              onChange({ ...value, padding: values });
            }}
          />
          <Border
            value={value?.border}
            onChange={val => {
              onChange({ ...value, border: val });
            }}
            title="Border"
          />
        </div>
      )}
    </div>
  );
};

export default OrderSummaryContent;
